
<template>

  <div id="page-user-view">
   <schedule-view-sidebar :isSidebarActive="addScheduleSidebar" @getdata="getdata" @closeSidebar="toggleScheduleSidebar" :data="scheduleData" />
   <add-student-sidebar :isStudentSidebarActive="addNewStudentSidebar" @getdata="getdata" @closeStudentSidebar="toggleStudentSidebar" :data="studentSidebarData" /> 
  <password-view-sidebar :isSidebarActive="addPasswordSidebar" @getdata="getdata" @closeSidebar="togglePassswordSidebar" :data="passwordSidebarData" />
  <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
  <user-setting-sidebar :isUserSettingSidebarActive="addSettingSidebar" @closeSidebar="toggleUserSettingDataSidebar" :data="userSidebarSettingData" />
    <vs-alert color="danger" title="User not found" :active.sync="user_not_found">
      <span>{{ $t('user.title') }} record with id: {{ $route.params.camuserId }} not found. </span>
      <span>
      </span>
    </vs-alert>
     <div id="user-data" v-if="cam_users" v-disable-all="checkBilling">
      <vx-card>
      <div class="flex">
        <h4 v-if="cam_users.middle_name" class="mb-base">
          {{ cam_users.fname + ' ' + cam_users.middle_name + ' ' + cam_users.lname }}</h4>
        <h4 v-else class="mb-base">{{ cam_users.fname + ' ' + cam_users.lname }}</h4>
        <i v-if="cam_users.invited" class="ml-5 mr-2">Invited</i>
        <vs-tooltip v-if="cam_users.invited && cam_users.pending" :text="'This '+$t('user.titlesmall')+' needs to be approved and it needs a password, before it can login.'" >
                   <feather-icon icon="InfoIcon" svgClasses="w-5 h-5" class="ml-1 text-danger"  />
                 </vs-tooltip>
                  <vs-tooltip v-else-if="cam_users.invited && !cam_users.pending" :text="'This '+$t('user.titlesmall')+'  needs a password, before it can login.'" >
                   <feather-icon icon="InfoIcon" svgClasses="w-5 h-5" class="ml-1 text-primary"  />
                 </vs-tooltip>
          <vx-tooltip v-if="cam_users.invited" text="Resend Invite" position="top">
          <feather-icon style="cursor: pointer" icon="MailIcon" svgClasses="h-5 w-5" class="ml-2"
                        @click="SendEmail(cam_users.email)" v-if="!!validEmail(cam_users.email)"/>
        </vx-tooltip>
        <span  v-else-if="cam_users.pending" class="flex">
            <i class="ml-5">Pending</i>
             <vs-tooltip  :text="'This '+$t('user.titlesmall')+' needs to be approved, before it can login.'" >
                   <feather-icon icon="InfoIcon" svgClasses="w-5 h-5" class="ml-1  text-danger"  />
                 </vs-tooltip>
             <!-- <vx-tooltip  text="Approve" position="top">
            <feather-icon style="cursor: pointer" icon="ToggleRightIcon" svgClasses="h-5 w-5" class="ml-2"
                        @click="openConfirmActiveStudent()"/>
            </vx-tooltip> -->
        </span>
         <span  v-if="cam_users.pending" class="flex">
             <vx-tooltip  text="Approve" position="top">
            <feather-icon style="cursor: pointer" icon="ToggleRightIcon" svgClasses="h-5 w-5" class="ml-2"
                        @click="openConfirmActiveStudent()"/>
            </vx-tooltip>
        </span>
        <span v-if="!cam_users.pending && !cam_users.invited">
        <vx-tooltip  :text="getTooltip(cam_users.status)" position="top">
        <vs-switch class="ml-2" :class="getcolor(cam_users.status)" @input="UpdateStatus(cam_users)" v-model="cam_users.status" ></vs-switch>
        </vx-tooltip>
        </span>
        <vx-tooltip v-if="cam_users.status" text="Reset Password" position="top">
          <feather-icon style="cursor: pointer" icon="KeyIcon" svgClasses="h-5 w-5" class="ml-2"
                        @click="passwordData(cam_users)"/>
        </vx-tooltip>
      <h5 class="ml-12 text-danger" v-if="checkBilling">This record is disabled because of its locations’ billing problems</h5>
      </div>
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4" v-if="cam_users.avatar">
              <img loading="lazy" :src="img_cdn+cam_users.avatar" class="rounded w-full" @click.stop="editData(cam_users)"/>
              <div class="dot-container">
                <div class="dot-circle" :class="'bg-' + getStatusColor(cam_users.last_login_time)">
                </div>
              </div>
            </div>
            <div class="img-container mb-2" v-else>
              <p class="rounded w-full bg-primary text-white" @click.stop="editData(cam_users)"
                 :data-letters="cam_users.fname[0].toUpperCase()"></p>
              <div class="dot-container">
                <div class="dot-circle" :class="'bg-' + getStatusColor(cam_users.last_login_time)">
                </div>
              </div>
              <!-- <span class="doticon" :class="'bg-' + getStatusColor(cam_users.last_login_time)" ></span> -->
            </div>
          </div>
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('user.profile.first_name') }}</td>
                <td>{{ cam_users.fname }}</td>
              <tr>
                <td class="font-semibold">{{ $t('user.profile.middle_name') }}</td>
                <td v-if="cam_users.middle_name">{{ cam_users.middle_name }}</td>
              <td v-else> N/A</td>
            </tr>
              <tr>
                <td class="font-semibold">{{ $t('user.profile.email') }}</td>
                <td><a class="text-inherit" :href="`mailto:${cam_users.email}`" @click.stop="">{{ cam_users.email | valid_email }}</a></td>
              </tr>

              <tr>

                <td class="font-semibold">{{ $t('user.profile.students') }}</td>
                <td v-if="cam_users.students.length<1">{{ $t('user.profile.no_students') }}</td>
                <td v-else>
                  <div v-for="(student, index) in cam_users.students" :key="index">
                    <vs-chip color="primary" v-if="student">
                      <vs-avatar v-if="student.image" :src="img_cdn+student.image"/>
                      <vs-avatar v-else />
                      <router-link v-if="lng!='dogs'"
                                   :to="{ path: '/'+ $t('route.student_profile.title') +'/' + student.id}"
                                   class="text-inherit "> {{ student.fname }} {{ student.lname }}
                      </router-link>
                      <router-link v-else :to="{ path: '/'+ $t('route.student_profile.title') +'/' + student.id}"
                                   class="text-inherit "> {{ student.fname }}
                      </router-link>

                    </vs-chip>
                  </div>
                </td>
              </tr>
              <tr v-if="cam_users.details">
                <td class="font-semibold">Requested Students</td>
                <td>{{cam_users.details}}</td>
              </tr>
                 <tr>
                <td class="font-semibold">Last Login Time</td>
                <span>
                <td v-if="cam_users.last_login_time"> {{ cam_users.last_login_time | formatDate}}</td>
                  <td v-else> N/A</td>
                </span>
              </tr>
              <tr>
                <td class="font-semibold">Created By</td>
                <span>
                <td v-if="added_by"> {{ added_by }}</td>
                  <td v-else> N/A</td>

                </span>
              </tr>
              <tr>
                <td class="font-semibold">Created At</td>
                <span>
                <td> {{ cam_users.created_at | formatDate}}</td>
                </span>
              </tr>


            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
            <tr>
              <td class="font-semibold">{{ $t('user.profile.last_name') }}</td>
              <td>{{ cam_users.lname }}</td>
            </tr>
              <tr>
                <td class="font-semibold">{{ $t('user.profile.user_name') }}</td>
                <td>{{ cam_users.username }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('user.profile.phone_no') }}</td>
                <td> 
                  <a v-if="cam_users.phone" class="text-inherit" :href="`tel:${cam_users.phone}`" @click.stop="">{{ cam_users.phone }}</a>
                  <p class="text-inherit" v-else>N/A</p>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('user.profile.location') }}</td>
               <td v-if="cam_users.locations.length>0"><span v-for="(location, index) in cam_users.locations" :key="index">
                <span>{{ location.name }}</span><br>
                </span>
                </td>
                <td v-else>N/A</td>
              </tr>
              <tr>
                <td class="font-semibold">Schedule</td>
                <td  v-if="cam_users.schedule">
                   <!-- <p class="font-semibold">{{student.schedule.name}}</p> -->
                   <span v-for="scheduledate in cam_users.schedule.scheduledates" :key="scheduledate.id">
                <span>
                {{ scheduledate.day + ' : '}}
                {{ scheduledate.start_time | formatTime }}   {{ scheduledate.end_time | formatTime }}
                </span>
                <br>
              </span>
              </td>
              <td v-else>No Schedule</td>
              </tr>
               <tr>
                <td></td>
                <td>
               <vs-button @click.native="addSchedule(cam_users)" size="small"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2" />
               <span>Add New</span></vs-button>
               <vs-button v-if="cam_users.schedule" class="ml-1" @click.native="confirmDeleteSchedule(cam_users)" color="danger" size="small">
               <span>Remove</span></vs-button>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Updated By</td>
                <span>
                <td v-if="update_by"> {{ update_by }}</td>
                 <td v-else> N/A</td>
                </span>
              </tr>
              <tr>
                <td class="font-semibold">Updated At</td>
                <span>
                <td v-if="cam_users.updated_at"> {{ cam_users.updated_at | formatDate}}</td>
                  <td v-else> N/A</td>

                </span>
              </tr>
              <tr>
                <td class="font-semibold">Today's Logins</td>
                <span>
                <td v-if="cam_users.logincounter"> {{ cam_users.logincounter.login_counter }}</td>
                  <td v-else>0</td>

                </span>
              </tr>
              <tr>
                <td class="font-semibold">Remaining Logins</td>
                <span>
                <td v-if="RemainingLogins =='0'">N/A </td>
                  <td v-else-if="RemainingLogins =='location_setting_not_enabled'">N/A</td>
                  <td v-else>{{ RemainingLogins }}</td>
                <vx-tooltip set-tooltip style="width: 10px;cursor: pointer ; margin: -33px 0px 0 38px;"
                            text="Reset Logins" position="top">
                  <feather-icon class="mr-10" icon="RefreshCwIcon" svgClasses="h-4 w-4"
                                @click.stop="resetUserLogins()"/>
                </vx-tooltip>
                </span>
              </tr>

            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click.native="editData(cam_users)">
              {{ $t('common.edit') }}
            </vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash"
                       @click.native="confirmDeleteRecord(cam_users.id)">{{ $t('common.delete') }}
            </vs-button>
             <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer" v-if="!checkBilling">
                  <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                  </div>

                  <vs-dropdown-menu>


                    <vs-dropdown-item>
                <span class="flex items-center" @click="passwordData(cam_users)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('user.action.password-reset') }}</span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="userSettingData(cam_users)">
                  <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('user.action.settting') }}s</span>
                </span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
          </div>

        </div>

      </vx-card>
       <!-- Permissions -->

     </div>


    <div id="demo-basic-card" v-if="cam_users.students" v-disable-all="checkBilling">
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        <h3 class="ml-5">{{ $t('student.profile_heading') }}</h3>
        <!-- ADD NEW -->
        <vs-button  class="p-3 ml-2 mr-4"  @click.native="addNewStudent(cam_users)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button>
        <!-- <div class="btn-add-new p-3 ml-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewCamUser(student)">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
        </div> -->
      </div>
      <p v-if="cam_users.students.length===0" class="ml-5 text-left mt-5">No data found</p>
      <!--      <p v-if="cam_users.students.length===0" class="ml-5 text-left mt-5">No {{ $t('student.titlesmall') }} has associate to this {{ $t('user.titlesmall') }}</p>-->
      <div class="vx-row mt-5" v-if="cam_users.students.length>0">
        <!-- USER PROFILE CARD 2 - MINIMAL -->
        <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(student, index) in cam_users.students"
             :key="index">
          <vx-card>
            <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/'+ student.id}"
                         class="text-inherit">
              <vs-avatar v-if="student.image" class="mx-auto mb-6 block" size="80px" :src="img_cdn+student.image"/>
              <p v-else class="bg-primary userstudentdot text-white mx-auto mb-6 block"
                 :data-letteruserstuent="student.fname[0].toUpperCase()"></p></router-link>
            <div class="text-center ">
                  <h4 v-if="lng!='dogs'">{{ student.fname }} {{ student.middle_name }} {{ student.lname }}</h4>
                  <h4 v-else>{{ student.fname }}</h4>
                  <!-- <p class="text-grey"><a :href="`mailto:${camuser.email}`" @click.stop="">{{ camuser.email }}</a></p> -->
                </div>


                <!-- <div class="flex justify-between flex-wrap">
                    <vs-button class="mt-4 mr-2 shadow-lg"  type="gradient" color="primary" gradient-color-secondary="#CE9FFC">Edit</vs-button>
                    <vs-button class="mt-4" type="border"  color="#b9b9b9">Remove</vs-button>
                </div> -->
                <template slot="footer">
                  <vs-divider/>
                  <div class="flex justify-between flex-wrap">
                        <span>
                            <p class="text-xl">{{ student.location.name }}</p>
                            <p class="text-grey">Location</p>
                        </span>
                    <span>
                            <p>{{ student.program.name }}</p>
                            <p class="text-grey">Program</p>
                        </span>
                    </div>
                    </template>
                </vx-card>
            </div>
        </div>
    </div>

    <div>
      <h3  class="ml-5">REPORTS</h3>
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">

    <vs-row class="mt-2">

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" class="pr-1">
        <vx-card title="Watch Time (Last 30 days)" style="height: 400px">
          <span v-if="getTotal > 0" class="font-bold">Total Watch Time : {{ getTotal }} Minutes</span>
          <span v-else >No data found</span>
          <vue-apex-charts v-if="getTotal > 0" type="radialBar" height="300" :options="radialBarChart.chartOptions"
                           :series="radialBarChart.series"></vue-apex-charts>
        </vx-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6" class="pl-1">
        <vx-card title="Daily Logins (Last 30 days)" style="height: 400px">

          <vue-apex-charts v-if="checkData > 0" type="area" height="300" :options="loginsChart.chartOptions"
                           :series="loginsChart.series"></vue-apex-charts>
          <span v-else >No data found</span>
        </vx-card>


      </vs-col>
    </vs-row>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import DataViewSidebar from './DataViewSidebar.vue'
import PasswordViewSidebar from './PasswordViewSidebar'
import AddStudentSidebar from './AddStudentSidebar'
import ScheduleViewSidebar from './ScheduleViewSidebar'
import UserSettingSidebar from './userSettingSideBar.vue'
import {
  CHECK_REMAINING_LOGINS_SETTING,
  GET_USER_LOGINS_REPORT,
  REMOVE_USER,
  REMOVE_USER_SCHEDULE,
  RESEND_INVITED_USER_EMAIL,
  RESET_USER_LOGINS,
  UPDATE_USER_STATUS,
  USER_LOG_DATA,
  USER_PROFILE_DATA,
  USER_WATCH_TIME_WEEKLY,
  ACTIVATE_USER,
  ACTIVE_USER_STUDENT,
  CREATE_USER_ACTIVITY,
  
} from '@/graphql'
import moment from 'moment'
import {colors} from '../../../themeConfig'


export default {
  name: 'Student.vue',
  components: {
    DataViewSidebar,
    PasswordViewSidebar,
    AddStudentSidebar,
    ScheduleViewSidebar,
    VueApexCharts,
    UserSettingSidebar

  },
  data () {
    return {
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      RemainingLogins: '0',
      studentlen: '',
      user_not_found: false,
      selected: [],
      managerlocation: [],
      name: '',
      email: '',
      msg: '',
      note: '',
      camnote: '',
      cam_users: '',
      lng: '',
      added_by: '',
      update_by: '',
      addPasswordSidebar: false,
      passwordSidebarData: {},
      playerOptions: {},
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      itemsPerPage: 4,
      isMounted: false,
      studentlist: '',
      dataMinuts: [],
      dataCamName: [],
      dataColorCode: [],
      TotalWatchTime: 0,
      LoginDate: '',
      Login_counter: 0,
      addNewStudentSidebar: false,
      studentSidebarData : {},
      addScheduleSidebar:false,
      scheduleData:{},
      checkBilling:false,
      DeleteID:null,
      userSidebarSettingData: {},
      addSettingSidebar: false,


    }
  },

  filters: {
    formatTime (value) {
      if (value) {
        return moment(String(value), 'h:mm A').format('h:mm A')
      }
    },
    formatDate (value) {
      if (value) {
        return moment.utc(value).local().format('MM/DD/YYYY h:mm A');
      }
    }
  },
  computed: {
    radialBarChart () {
      return {
        series: this.getMinuts,

        chartOptions: {


          colors: this.getColors,
          labels: this.getLables,
          legend: {
            show: true,
            floating: true,
            fontSize: '16px',
            position: 'left',
            offsetX: -10,
            offsetY: 0,
            labels: {
              useSeriesColors: true
            },
            markers: {
              size: 0
            },
            formatter (seriesName, opts) {
              return `${seriesName  }:  ${  opts.w.globals.series[opts.seriesIndex]  } Min`
            },
            itemMargin: {
              vertical: 3
            }
          },
          plotOptions: {
            radialBar: {
              offsetX: 100,
              offsetY: 0,
              dataLabels: {
                name: {
                  fontSize: '20px'
                },
                value: {
                  fontSize: '16px',
                  formatter (val) {
                    return `${val  } Minutes`
                  }
                },
                total: {
                  show: false,
                  label: 'Total',
                  formatter (w) {
                    // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                    return `${this.getTotal  } Minutes`
                  }
                }
              }
            }
          }

        }
      }
    },

    loginsChart () {
      return {
        colors: [colors.primary],
        series: [
          {
            name: 'Logins# ',
            data: this.getLoginCounter
          }
        ],
        chartOptions: {
          dataLabels: {
            enabled: false
          },
          chart: {
            sparkline: {
              enabled: true
            }
          },
          stroke: {
            curve: 'smooth',
            colors: colors.primary
          },
          fill: {
            type: 'solid',
            colors: colors.primary,
            opacity: [1]
          },
          tooltip: {
            enabled: true,
            y: {
              formatter (value) {
                return value
              }
            }
          },
          xaxis: {

            categories: this.getDates
          },
          yaxis: {
            labels: {
              show: false
            }
          }
        }

      }
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    getTotal (val) {
      // alert(this.TotalWatchTime)
      return this.TotalWatchTime
    },
    getMinuts () {
      return this.dataMinuts
    },
    getColors () {
      return this.dataColorCode
    },
    getLables () {

      return this.dataCamName
    },
    getDates () {
      return this.LoginDate
    },
    getLoginCounter () {
      return this.Login_counter
    },
    checkData () {
      return this.Login_counter.length
    },
  },
  methods: {
      userSettingData (data) {

      this.userSidebarSettingData = data
      this.toggleUserSettingDataSidebar(true)

    },
     toggleUserSettingDataSidebar (val = false) {
      this.addSettingSidebar = val
    },
    addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    toggleScheduleSidebar (val = false) {
      this.addScheduleSidebar = val
    },
    addNewStudent (data) {
      this.studentSidebarData = data
      this.toggleStudentSidebar(true)
    },
    toggleStudentSidebar (val = false) {
      this.addNewStudentSidebar = val
    },
    getdata (value) {
      if (value) {
        this.get()
      }
    },
    getcolor (status) {
      if (status) {
        return 'bg-success'
      } else {
        return 'bg-danger '
      }
    },
    getTooltip (status) {
      if (status) {
        return 'Click to Disable'
      } else {
        return 'Click to Enable'
      }
    },
    validEmail (value) {
      if (value.slice(0, 8) === 'temp-kv-'  &&  /^\d+$/.test(value.slice(9, 18))  &&  value.slice(value.length - 14) === 'kidsvision.com') {
        return false
      } else {
        return true
      }
    },
    watchTimeMonthlyReport () {
      this.$apollo
        .mutate({
          mutation: USER_WATCH_TIME_WEEKLY,
          variables: {
            id: this.$route.params.camuserId
          }
        }).then(response => {
          const minuts = []
          const colors = []
          const camera_name = []
          let sum = 0
          if (response) {
            for (let i = 0; i < response.data.userWatchTimeWeekly.length; i++) {
              minuts.push(response.data.userWatchTimeWeekly[i].minutes)
              colors.push(response.data.userWatchTimeWeekly[i].camera_color)
              camera_name.push(response.data.userWatchTimeWeekly[i].camera_name)
              sum += parseInt(response.data.userWatchTimeWeekly[i].minutes)

            }
            this.dataMinuts = minuts
            this.dataCamName = camera_name
            this.dataColorCode = colors
            this.TotalWatchTime = sum

          }

        })
        .catch(error => {
          console.log(error)
        })
    },
    getUserLoginsReport () {
      this.$apollo
        .mutate({
          mutation: GET_USER_LOGINS_REPORT,
          variables: {
            id: this.$route.params.camuserId
          }
        }).then(response => {
          if (response) {
            const date = []
            const counter = []
            for (let i = 0; i < response.data.getUserLoginsReport.length; i++) {
              date.push(response.data.getUserLoginsReport[i].date)
              counter.push(parseInt(response.data.getUserLoginsReport[i].login_counter))
            }

            this.LoginDate = date
            this.Login_counter = counter
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    confirmDeleteSchedule (user) {
      this.DeleteID = user
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Do you really want to remove schedule for this ${this.$t('user.titlesmall')}?`,
        accept: this.removeSchedule,
        acceptText: 'Delete'
      })
    },

    removeSchedule () {
      this.$apollo
        .mutate({
          mutation: REMOVE_USER_SCHEDULE,
          variables: {
            id: this.DeleteID.id,
            schedule_id: this.DeleteID.schedule.id
          }
        }).then(response => {
          if (response.data.deleteUserSchedule.status === 'Success') {
            this.StatusScheduleDeleteSuccess()
            this.get()
          }
        }).catch(error => {
          console.log(error)
        })

    },
    confirmDeleteRecord (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${this.cam_users.fname} ${this.cam_users.lname}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'

      })
    },
    StatusScheduleDeleteSuccess () {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Schedule deleted successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusSuccess () {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Deleted successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFaild () {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Failed to Delete',
        color: 'danger',
        position: 'top-right'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      this.$apollo
        .mutate({
          mutation: REMOVE_USER,
          variables: {
            id: this.cam_users.id
          }
        })
        .then(response => {
          if (response.data.deleteUser.status === 'Success') {
            this.userActivity(this.cam_users.id,"deleted")
            this.StatusSuccess()
            this.$router.push(this.$t('menu.users.menu_path'))

          } else {
            this.StatusFaild()
          }
        }).catch(error => {
          console.log(error)
        })

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
      //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted',
        position:'top-right'
      })
    },
    editData (data) {
      if(!this.checkBilling){
      this.sidebarData = data
      this.toggleDataSidebar(true)
      }
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    passwordData (data) {
      this.passwordSidebarData = data
      this.togglePassswordSidebar(true)
    },
    togglePassswordSidebar (val = false) {
      this.addPasswordSidebar = val
    },
    removeStudent (id) {
      for (let i = 0; i < this.cam_users.students.length; i++) {
        if (this.cam_users.students[i].id == id) {
          this.cam_users.students.splice(i, 1)
          if (this.cam_users.students.length == 0) {
            this.cam_users.students = 'No Students'
          }
        }
      }
    },
    getUserLogData () {
      this.$apollo
        .mutate({
          mutation: USER_LOG_DATA,
          variables: {
            id: this.$route.params.camuserId,
            object_type: 'App\\Models\\User'
          }
        })
        .then(response => {

          for (let i = 0; i < response.data.getUserLogData.data.length; i++) {
            if (response.data.getUserLogData.data[i]) {
              if (response.data.getUserLogData.data[i].activity == 'added') {
                this.added_by = `${response.data.getUserLogData.data[i].user.fname} ${response.data.getUserLogData.data[i].user.lname}`
              }
            }
            if (response.data.getUserLogData.data[i]) {
              if (response.data.getUserLogData.data[i].activity == 'updated') {
                this.update_by = `${response.data.getUserLogData.data[i].user.fname} ${response.data.getUserLogData.data[i].user.lname}`
              }
            }
          }
        })


    },
    UpdateStatus (camuser) {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_STATUS,
          variables: {
            id: camuser.id,
            status: camuser.status
          }
        })
        .then(response => {
          if (response.data.updateUserStatus.status == 'SUCCESS') {
            this.userActivity(camuser.id,"updated")
            this.UpdateSuccess()

          }
        }).catch(error => {
          console.log(error)
        })
    },
    SendEmail (email) {
      this.$apollo
        .mutate({
          mutation: RESEND_INVITED_USER_EMAIL,
          variables: {
            email
          }
        })
        .then(response => {
          if (response.data.resendInvitedUserEmail.status == 'SUCCESS') {
            this.EmailStatus()


          } else if (response.data.resendInvitedUserEmail.status == 'ALREADY_APPROVED') {
            this.emailAlreadyApprovedNotification()

          }
        }).catch(error => {
          console.log(error)
        })
    },
    UpdateSuccess () {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Update successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    EmailStatus () {
      this.$vs.notify({
        title: 'Email Sent',
        text: 'Email sent sucessfully',
        color: 'success',
        position: 'top-right'
      })
    },
    getStatusColor (val) {
      if (val) {
        var val = moment(val).format('YYYY-MM-DD HH:mm')
        const today = new Date()
        let date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
        date = moment(date).format('YYYY-MM-DD')
        for (let i = 0; i < 6; i++) {
          var time = moment().utc().subtract(i, 'minutes').format('LTS')
          var time = moment(time, ['h:mm A']).format('HH:mm')
          const dateTime = `${date} ${time}`
          const condition = val == dateTime
          if (condition) {
            return 'success'
          }
        }
        return 'grey'
      } else {
        return 'grey'
      }
    },
    get () {
      this.$apollo
        .mutate({
          mutation: USER_PROFILE_DATA,
          variables: {
            id: this.$route.params.camuserId
          }
        })
        .then(response => {
          this.getUserLogData()
          const locations = []
          if(response.data.user.locations){
          for (let loc = 0; loc < response.data.user.locations.length; loc++) {
            const element = response.data.user.locations[loc];
            if(!element.billing){
               this.checkBilling=true
               break
            }
          }  
          }
        this.cam_users = response.data.user
        }).catch(error => {
          console.log(error)
        })

    },
    checkRemainingLogins () {
      this.$apollo
        .mutate({
          mutation: CHECK_REMAINING_LOGINS_SETTING,
          variables: {
            id: this.$route.params.camuserId
          }
        })
        .then(response => {
          if (response) console.log(response.data.checkRemainingLogins.data)
          this.RemainingLogins = response.data.checkRemainingLogins.data
        }).catch(error => {

          console.log(error)
          this.RemainingLogins == '0'

        })
    },
    resetUserLogins () {
      this.$apollo
        .mutate({
          mutation: RESET_USER_LOGINS,
          variables: {
            id: this.cam_users.id

          }
        })
        .then(response => {
          if (response.data.resetUserLogins.status == 'SUCCESS') {
            this.successNotification()
            this.checkRemainingLogins()


          } else if (response.data.resetUserLogins.status == 'NOT_FOUND') {
            this.failedNotification()
          }


        })
    },
    failedNotification () {
      this.$vs.notify({
        title: `${this.$t('user.alert_title')} Detail`,
        text: 'User data not found!',
        color: 'danger',
        position: 'top-right'
      })
    },
    successNotification () {
      this.$vs.notify({
        title: 'Reset Daily Logins',
        text: `${this.$t('user.alert_title')} number of logins have been reset for the day.`,
        color: 'success',
        position: 'top-right'
      })
    },
      openConfirmActiveStudent() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm`,
        text: `It will also activate the attached ${this.$t('student.titlesmall')}s.`,
        accept: this.ActiveStudent
      })
    }, 
      ActiveStudent(){
      this.$apollo
        .mutate({
          mutation: ACTIVE_USER_STUDENT,
          variables: {
            id :this.$route.params.camuserId,
          }
        })
        .then(response => {
          if (response.data.activateUserStudent.status==='Success') {
              this.cam_users.pending=false
              this.userActivity(this.$route.params.camuserId,"updated")
              this.$vs.notify({
              color: 'success',
              title: this.$t('user.alert_title'),
              position:'top-right',
              text: 'Status updated successfully!'
            })
          }
        }).catch(error => {
          console.log(error)
        })
    },
     userActivity (id,action) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\User',
            activity:action
          }
        })
    },
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()
    this.checkRemainingLogins()
    this.watchTimeMonthlyReport()
    this.getUserLoginsReport()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}
// .set-tooltip{

// }
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }


  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

  #demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
  }
}

#demo-basic-card {
  margin-top: 1.5rem!important;
}
[data-letters]:before {
  content:attr(data-letters);
  display:block;
  border-radius: .25rem !important;
  font-size:100px;
  width: 100% !important;
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  text-transform: none;
  text-decoration: none;
  height:110px;
  line-height:110px;
  text-align:center;
}
[data-letteruserstuent]:before {
  content:attr(data-letteruserstuent);
   }
  .userstudentdot{
  display:inline-block;
  font-size:50px;
  width:80px;
  height:80px;
  line-height:80px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  margin-left: 100px;
  margin-bottom: 30px;
  }
.doticon {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 100%;

}
 .dot-container {
  position: relative;
}
.dot-circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color:transparent;
  border: 1px solid white;
  bottom: -2px;
  right: -2px;
  margin-left: 100%;
  position: absolute;
}
</style>
